<template>
	<el-breadcrumb class="app-levelbar" separator-class="el-icon-arrow-right">
		<div v-if="levelList.length>1">
			<el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path">
				<span v-if='index==levelList.length-1' class="no-redirect">{{item.meta && item.meta.title}}</span>
				<router-link v-else :to="{name:item.meta && item.meta.activeNav}"
							 :class="!item.meta.sign?'crumbLink':'signLink'">{{item.meta && item.meta.title}}
				</router-link>
			</el-breadcrumb-item>
		</div>

		<span v-else class="title">{{levelList[0] && levelList[0].meta && levelList[0].meta.title}}</span>

		<slot></slot>
	</el-breadcrumb>
</template>

<script>
	export default {
		created() {
			this.getBreadcrumb()
		},
		data() {
			return {
				levelList: null
			}
		},
		methods: {

			getBreadcrumb() {
				let matched = this.$route.matched.filter(item => {
					if (!item.meta || !item.meta.title) {
						return false
					}
					let authorPath = process.env.authorPath


					return item.path !== '/'+authorPath

				})
				// v-if="levelList[levelList.length-1].name!=levelList[0].name"
				const first = matched[0]
				// if (first && (first.name !== '专区首页' || !(first.path === '' || first.path === '/'))) {
				// 	matched = [{name: '专区首页', path: '/'}].concat(matched)
				// }
				this.levelList = matched
			},


		},
		watch: {
			$route() {
				this.getBreadcrumb()
			}
		},
		props: {
			breadCrumb: {
				type: Object
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.app-levelbar.el-breadcrumb {
		background: #fff;
		font-size: 16px;
		line-height: 50px;
		padding-left: 30px;
		position: relative;
		margin-bottom: 5px;
		color: #333;
		.no-redirect {
			color: #aaa;
			cursor: text;
		}
		.crumbLink {
			color: #606266 !important;
			font-size: 16px;
			font-weight: normal;
		}
		.crumbLink:hover {
			color: #1aaee5 !important;
			cursor: pointer;
		}
		.signLink {
			color: #606266 !important;
			font-size: 16px;
			font-weight: normal;
		}
		.signLink:hover {
			color: #606266 !important;
			cursor: text;
		}
	}

	.title {
		font-size: 16px;
		color: #333;
		/*font-weight: bold;*/
	}
</style>



// WEBPACK FOOTER //
// src/views/layout/Levelbar.vue